import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2, Heading4 } from '@ui/Typography'
import { Tabs } from '@ui/components/Tabs'
import type { Tab } from '@ui/components/Tabs'

import { LuckyDrawCampaign } from '@model/LuckyDrawDto'

import { WonMessage } from './WonMessage'

import styles from '../LuckyDraw.modal.module.scss'

export enum LuckyDrawTab {
  Overview = 'overview',
  Prizes = 'prizes',
  History = 'history',
  NoTab = 'no_tab',
}

interface DetailsSectionProps {
  activeTab: LuckyDrawTab
  setActiveTab: (tab: LuckyDrawTab) => void
  children: React.ReactNode
  campaign: LuckyDrawCampaign
  won: boolean
  onClose: () => void
  sectors: any[]
  winner: number
  setWon: (won: boolean) => void
  isSpinning?: boolean
}

export const DetailsSection: React.FC<DetailsSectionProps> = ({
  activeTab,
  setActiveTab,
  children,
  won,
  onClose,
  sectors,
  winner,
  setWon,
  isSpinning = false,
}) => {
  const { t } = useTranslation()

  const luckyDrawTabs: Tab<LuckyDrawTab>[] = [
    {
      id: LuckyDrawTab.Overview,
      label: t('luckyDraw.tabs.overview'),
    },

    {
      id: LuckyDrawTab.Prizes,
      label: t('luckyDraw.tabs.prizes'),
    },
    {
      id: LuckyDrawTab.History,
      label: t('luckyDraw.tabs.history'),
      disabled: isSpinning,
    },
  ]

  return (
    <section className={classNames(styles.detailsBox)}>
      <div className={styles.wrapper}>
        <div className={styles.titleBox}>
          <Body2>{t('luckyDraw.subtitle')}</Body2>
          <Heading4 className={styles.title} semibold>
            {t('luckyDraw.newTitle')}
          </Heading4>
        </div>
        <div className={styles.tabsWrapper}>
          <Tabs
            tabs={luckyDrawTabs}
            initialIndex={luckyDrawTabs.findIndex((t) => t.id === activeTab)}
            noActive={won}
            center
            onTabClick={(tab) => {
              if (won) setWon(false)
              setActiveTab(tab.id as LuckyDrawTab)
            }}
          />
        </div>

        <div className={styles.tabsContent}>
          {won ? (
            <WonMessage sectors={sectors} winner={winner} onClose={onClose} />
          ) : (
            <div className={styles.tabPanel}>{children}</div>
          )}
        </div>
      </div>
    </section>
  )
}
